import { render, staticRenderFns } from "./Bigcontent.vue?vue&type=template&id=03ce2f8a"
import script from "./Bigcontent.vue?vue&type=script&lang=js"
export * from "./Bigcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports